import {
  Box,
  Button,
  Icon,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useMediaQuery,
  useToast
} from '@chakra-ui/react';
import { useContext, useEffect, useState } from 'react';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { DetalhesIcon } from '../../../../../assets/icons/DetalhesIcon';
import VisualizationContext from '../../../../../contexts/VisualizationContext';
import { api } from '../../../../../services/api';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { delay } from '../../../../../utils/delay';
import { getTelephoneOrCellPhoneNumber } from '../utils/getTelephoneOrCellPhoneNumber';

function DetalhesVendedor() {
  const { state }: any = useLocation();

  const { visualizationState, setVisualizationState } =
    useContext(VisualizationContext);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [vendedor, setVendedor] = useState<any>(state?.vendedor || {});
  const [loadingVincular, setLoadingVincular] = useState(false);
  const [isMobile] = useMediaQuery('(max-width: 920px)');

  const navigate = useNavigate();

  const toast = useToast();

  const handleExcluirVendedor = async () => {
    try {
      setLoadingVincular(true);
      const { data } = await apiSensedia.put(
        `oportunidades-sulamerica/painel-leads/alterar-status-usuario`,
        {
          id: vendedor.id,
          status: 'excluido'
        }
      );

      if (vendedor.tipo === 'clt') {
        await delay(2500);
        const link =
          process.env.NODE_ENV === 'production'
            ? 'https://corretor.sulamericaseguros.com.br/area-logada/#/acessos/gestao-usuarios'
            : 'https://portalcorretord.sulamerica.br/area-logada/#/acessos/gestao-usuarios';
        window.open(link, '_blank');
        setLoadingVincular(false);
        navigate('/corretor/leads/perfis');
        return;
      }

      toast({
        position: 'top',
        description: `Vendedor ${vendedor.nome} foi excluído com sucesso!!!`,
        status: 'success',
        duration: 7000,
        isClosable: true
      });

      setLoadingVincular(false);
      navigate('/corretor/leads/perfis');
    } catch (error: any) {
      console.log(error);

      const errorObj = error?.toJSON();
      toast({
        position: 'top',
        description: (
          <Box>
            <Text>
              {' '}
              Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
              minutos e tente fazer login novamente, se persistir, por favor
              entrar em contato.
            </Text>
            <Text>
              {errorObj?.status && (
                <>
                  <br />
                  <b>Detalhes:</b>
                  <br />
                </>
              )}
              {(errorObj?.status || error?.response?.data?.statusCode) && (
                <>{errorObj.status ?? error.response.data.statusCode}</>
              )}
              {errorObj?.status &&
                (error?.response?.data?.message || errorObj?.message) &&
                ' - '}
              {(error?.response?.data?.message || errorObj?.message) && (
                <>{error.response.data.message ?? errorObj.message}</>
              )}
            </Text>
          </Box>
        ),
        duration: 15000,
        isClosable: true,
        status: 'error'
      });

      onClose();
    }
  };

  return (
    <>
      <div className="tw-flex tw-justify-between tw-items-center tw-px-[4vw] tw-py-[2vh] tw-w-[100%] tw-bg-[#EBEBEB] ">
        <p className="tw-font-bold tw-text-[1.8rem]">Detalhes do vendedor</p>
        {!isMobile && (
          <div>
            <div className="tw-font-bold">Alterar modo de visualização</div>
            <div className="tw-flex tw-gap-2">
              <div className="tw-flex tw-gap-1">
                <div>
                  <Link to="/corretor/leads/">
                    <input
                      name="options"
                      value="gestao"
                      onChange={(e) => {
                        setVisualizationState(e.target.value);
                      }}
                      type="radio"
                      defaultChecked={visualizationState === 'gestao'}
                      className="tw-text-2xl tw-font-bold tw-mb-4"
                    />
                  </Link>
                </div>
                <div>Modelo de Gestão</div>
              </div>
              <div className="tw-flex tw-gap-1">
                <div>
                  <Link to="/corretor/leads/">
                    <input
                      name="options"
                      type="radio"
                      value="card"
                      onChange={(e) => {
                        setVisualizationState(e.target.value);
                      }}
                      defaultChecked={visualizationState === 'card'}
                      className="tw-text-2xl tw-font-bold tw-mb-4"
                    />
                  </Link>
                </div>
                Modelo de Cards
              </div>
            </div>
          </div>
        )}
      </div>
      <div
        className={
          isMobile
            ? 'tw-flex tw-flex-col tw-w-[100%] tw-h-[100vh] tw-mt-5 '
            : 'tw-flex tw-flex-col tw-w-[100%] tw-h-[100vh] tw-px-[8vw] tw-mt-5 '
        }
      >
        <div className="tw-mb-[2vh] tw-px-[4vw]">
          <div className={isMobile ? 'tw-text-[1rem]' : 'tw-mb-[2vh]'}>
            <Link to={'/corretor/leads/perfis'}>
              <button className="tw-font-bold tw-text-[#001E64]">
                <Icon as={AiOutlineArrowLeft} mr="0.5rem" />
                Voltar
              </button>
            </Link>
          </div>
        </div>
        <div
          className={
            isMobile
              ? 'tw-flex tw-w-[100%] tw-px-[4vw] tw-justify-center tw-items-start tw-pb-2'
              : 'tw-flex tw-w-[100%] tw-justify-center tw-items-start tw-pb-2'
          }
        >
          <div
            className={
              isMobile
                ? 'tw-bg-[#F5F5F5] tw-w-[100%] tw-flex tw-flex-col tw-px-[4vw] tw-pt-[4vh] tw-rounded-3xl tw-pb-[2vh]'
                : 'tw-bg-[#F5F5F5] tw-w-[60vw] tw-flex tw-flex-col tw-px-[4vw] tw-pt-[4vh] tw-rounded-3xl tw-pb-[2vh]'
            }
          >
            <div className="tw-flex tw-w-[100%] tw-justify-between">
              <p className="tw-font-bold tw-text-[2.2vh] ">Dados pessoais</p>
              <div>
                <Link
                  to={'/corretor/leads/vendedor/painel'}
                  state={{ vendedor: vendedor, perfis: state.perfis }}
                >
                  <button className="tw-pr-[2vh]">
                    <DetalhesIcon />
                    <p>Ver painel de cards</p>
                  </button>
                </Link>
                <button
                  className=""
                  onClick={() => {
                    onOpen();
                  }}
                >
                  <Icon
                    h="1.5rem"
                    w="1.5rem"
                    as={RiDeleteBin6Line}
                    color="#AA2C23"
                  />
                  <p>Excluir</p>
                </button>
              </div>
            </div>
            <div>
              <div className="tw-my-[2vh]">
                <p>CPF / ID</p>
                <input
                  className={
                    isMobile
                      ? 'tw-border-[#001E64] tw-border-[0.1rem] tw-w-[100%] tw-px-[0.8rem] tw-py-[0.5rem] tw-rounded-[0.3rem]'
                      : 'tw-border-[#001E64] tw-border-[0.1rem] tw-w-[30vw] tw-px-[0.8rem] tw-py-[0.5rem] tw-rounded-[0.3rem]'
                  }
                  placeholder="Sem ID"
                  value={vendedor.id}
                ></input>
              </div>
              <p className="tw-my-[3vh] tw-border-b-2"></p>
              <div className="tw-my-[2vh]">
                <p className="tw-my-[1vh]">Nome</p>
                <input
                  className={
                    isMobile
                      ? 'tw-border-[#001E64] tw-border-[0.1rem] tw-w-[100%] tw-px-[0.8rem] tw-py-[0.5rem] tw-rounded-[0.3rem]'
                      : 'tw-border-[#001E64] tw-border-[0.1rem] tw-w-[30vw] tw-px-[0.8rem] tw-py-[0.5rem] tw-rounded-[0.3rem]'
                  }
                  placeholder="Sem nome"
                  value={vendedor.nome || ''}
                  disabled
                ></input>
              </div>
              <div
                className={
                  isMobile
                    ? 'tw-flex tw-flex-col tw-w-[100%] tw-my-[2vh]'
                    : 'tw-flex tw-w-[100%] tw-my-[2vh]'
                }
              >
                <div className="tw-w-[100%]">
                  <p className="tw-my-[1vh]">Telefone </p>
                  <input
                    className={
                      isMobile
                        ? 'tw-border-[#001E64] tw-border-[0.1rem] tw-w-[100%] tw-px-[0.8rem] tw-py-[0.5rem] tw-rounded-[0.3rem]'
                        : 'tw-border-[#001E64] tw-border-[0.1rem] tw-w-[30vw] tw-px-[0.8rem] tw-py-[0.5rem] tw-rounded-[0.3rem]'
                    }
                    placeholder="Sem telefone"
                    value={vendedor.telefone_1 || ''}
                    disabled
                  ></input>
                </div>
              </div>
              <div
                className={
                  isMobile
                    ? 'tw-flex tw-flex-col tw-w-[100%] tw-my-[2vh]'
                    : 'tw-flex tw-w-[100%] tw-my-[2vh]'
                }
              >
                <div className="tw-w-[100%]">
                  <p className="tw-my-[1vh]">Telefone adicional (opcional)</p>
                  <input
                    className={
                      isMobile
                        ? 'tw-border-[#001E64] tw-border-[0.1rem] tw-w-[100%] tw-px-[0.8rem] tw-py-[0.5rem] tw-rounded-[0.3rem]'
                        : 'tw-border-[#001E64] tw-border-[0.1rem] tw-w-[30vw] tw-px-[0.8rem] tw-py-[0.5rem] tw-rounded-[0.3rem]'
                    }
                    placeholder="Sem telefone"
                    value={vendedor.telefone_2 || ''}
                    disabled
                  ></input>
                </div>
              </div>
              <div className="tw-my-[2vh]">
                <div>
                  <p className="tw-my-[1vh]">E-mail</p>
                  <input
                    className={
                      isMobile
                        ? 'tw-border-[#001E64] tw-border-[0.1rem] tw-w-[100%] tw-px-[0.8rem] tw-py-[0.5rem] tw-rounded-[0.3rem]'
                        : 'tw-border-[#001E64] tw-border-[0.1rem] tw-w-[30vw] tw-px-[0.8rem] tw-py-[0.5rem] tw-rounded-[0.3rem]'
                    }
                    placeholder="Sem email"
                    value={vendedor.email}
                    disabled
                  ></input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        closeOnOverlayClick={true}
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        size="md"
      >
        <ModalOverlay />
        <ModalContent textAlign="center">
          <ModalHeader>Excluir vendedor</ModalHeader>
          <ModalBody mt="1rem">
            <div>
              <div>
                <p></p>
              </div>
              <div>
                {vendedor.tipo === 'clt' && (
                  <p>
                    Excluir vendedor Você deseja excluir o vendedor
                    <br />
                    <span className="tw-font-bold">({vendedor.nome})</span>? Ao
                    excluir, os leads voltarão para distribuição e você não
                    conseguirá selecioná-lo. <br />
                    <br />
                    Para validar a exclusão, exclua-o no{' '}
                    <span className="tw-font-bold">
                      Gerenciamento de Acesso.{' '}
                    </span>
                    Uma nova guia será aberta após{' '}
                    <span className="tw-font-bold">3 segundos</span> para você
                    prosseguir com a exclusão. Você deseja inativar <br />
                  </p>
                )}
                {vendedor.tipo === 'autonomo' && (
                  <p>
                    Você deseja excluir o vendedor
                    <br />
                    <span className="tw-font-bold">({vendedor.nome})</span>? Ao
                    excluir, os leads
                    <br /> voltarão para distribuição e você <br /> não
                    conseguirá selecioná-lo. <br />
                  </p>
                )}
              </div>
            </div>
          </ModalBody>
          <ModalFooter justifyContent="space-between" px="4rem">
            <button
              onClick={onClose}
              disabled={loadingVincular}
              className="tw-font-bold tw-border-[0.2rem] tw-w-[9rem] tw-py-[0.8rem] tw-rounded-full tw-border-[#001E64] tw-text-[#001E64]"
            >
              Cancelar
            </button>
            {loadingVincular === false ? (
              <button
                onClick={handleExcluirVendedor}
                className="tw-font-bold  tw-w-[9rem] tw-py-[0.8rem] tw-rounded-full tw-bg-[#FF5000] tw-text-[#FFFF]"
              >
                Sim
              </button>
            ) : (
              <button
                disabled
                className={
                  isMobile
                    ? 'tw-bg-[#FF5000] tw-flex tw-items-center tw-justify-center tw-text-[#EBEBEB] tw-font-bold tw-border-[0.1rem] tw-w-[100%] tw-h-[5vh] tw-rounded-3xl'
                    : 'tw-bg-[#FF5000] tw-flex tw-items-center tw-ml-1 tw-justify-center tw-text-[#EBEBEB] tw-font-bold tw-w-[9rem] tw-h-[5vh] tw-rounded-3xl'
                }
              >
                <svg
                  className="tw-animate-spin tw-h-5 tw-w-4 tw-mr-1 "
                  viewBox="0 0 24 24"
                >
                  <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
                    className="spinner_P7sC"
                    fill="white"
                  />
                </svg>
                Processando...
              </button>
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default DetalhesVendedor;
